var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.user.get('image'))?_c('img',{staticClass:"avatar",style:({
      'font-size': _vm.size ? _vm.size + 'px' : '40px',
    }),attrs:{"src":_vm.user.get('image')}}):_c('div',{staticClass:"avatar d-flex align-items-center justify-content-center",style:({
      'font-size': _vm.size ? _vm.size + 'px' : '40px',
    })},[_c('span',[_vm._v(_vm._s(_vm.initials))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }